import {
    Button,
    Form,
    InputNumber,
} from 'antd';
import {useForm} from 'antd/es/form/Form';
import React, {useState, FC} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {DateCell} from 'components/table/columns/date-cell/date-cell';
import {ReactComponent as KebabIcon} from 'shared/assets/kebab.svg';
import {DATE, DATE_DMY} from 'shared/constants/date-format';
import {showMessage} from 'shared/utils';

import {usePutAisSummaryTransactionProtocolTableRowValueMutation} from '../../api/api';
import {MAX_OPERATIONS, MIN_OPERATIONS} from '../../model/constants';
import {ISummaryTransactionProtocolDto} from '../../model/types';

interface IEditRowModalOpenerProps {
  initialRowValues: ISummaryTransactionProtocolDto;
  refetchTableData: () => {};
}

export const EditRowModalOpener: FC<IEditRowModalOpenerProps> = ({
    initialRowValues,
    refetchTableData,
}: IEditRowModalOpenerProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = useForm<ISummaryTransactionProtocolDto>();

    const [
        updateAisSummaryTransactionProtocolTableRowValue,
    ] = usePutAisSummaryTransactionProtocolTableRowValueMutation();

    const handleCancel = () => {
        setIsModalOpen(prev => !prev);
        form.resetFields();
    };

    const handleSave = async () => {
        const values: ISummaryTransactionProtocolDto = {
            ...initialRowValues,
            ...form.getFieldsValue(),
        };
        form.validateFields().then(async () => {
            try {
                await updateAisSummaryTransactionProtocolTableRowValue(values).unwrap();
                showMessage({message: 'Запись успешно обновлена'});
                refetchTableData();
            } catch (error) {
                console.error('Ошибка при попытке редактирования записи: ', error);
            } finally {
                handleCancel();
            }
        });
    };

    return (
        <ModalOpenerComponent
            isOpen={isModalOpen}
            shouldConfirm={() => form.isFieldsTouched()}
            setIsOpen={setIsModalOpen}
            controlLabels={{
                save: 'Сохранить',
            }}
            handleCancel={handleCancel}
            handleSave={handleSave}
            tooltip={{title: 'Редактировать'}}
            component={(
                <Button
                    icon={(<KebabIcon />)}
                    style={{padding: 0}}
                    type="primary"
                />
            )}
            modalProps={{
                title: 'Редактирование записи сводного протокола операций',
                forceRender: true,
                destroyOnClose: false,
                centered: true,
                width: '680px',
            }}
        >
            <Form
                className="form-flex"
                layout="vertical"
                form={form}
                initialValues={initialRowValues}
            >
                <Form.Item
                    label="Дата начала отчетного периода"
                    name="startPeriodDate"
                    data-type="date"
                >
                    <DateCell
                        requestFormat={DATE}
                        format={DATE_DMY}
                    />
                </Form.Item>

                <Form.Item
                    label="Дата окончания отчетного периода"
                    name="endPeriodDate"
                    data-type="date"
                >
                    <DateCell
                        requestFormat={DATE}
                        format={DATE_DMY}
                    />
                </Form.Item>

                <Form.Item
                    label="Общее количество операций"
                    name="totalTransactionsAmt"
                >
                    <InputNumber
                        placeholder="Введите общее количество операций"
                        min={MIN_OPERATIONS}
                        max={MAX_OPERATIONS}
                    />
                </Form.Item>

                <Form.Item
                    label="Количество операций с наличием первичных учетных документов"
                    name="transactionsWithDocs"
                >
                    <InputNumber
                        placeholder="Введите количество операций с наличием первичных учетных документов"
                        min={MIN_OPERATIONS}
                        max={MAX_OPERATIONS}
                    />
                </Form.Item>
            </Form>
        </ModalOpenerComponent>
    );
};
